/**   // ===================  Android와의 통신 에러발생 시 호출됨 =================== //  */
function useOnErrorAction() {
  window.onErrorAction = (action, id, errMsg) => {
    console.log(
      '@@@ WEBVIEW ErrorAction @@@ action(' +
        action +
        '), id(' +
        id +
        '), errMsg(' +
        errMsg +
        ')',
    );
  };
}

export default useOnErrorAction;
